import ReactDOM from 'react-dom';
import { Auth0Provider } from '@auth0/auth0-react';

import reportWebVitals from './reportWebVitals';
import App from './App';
import { DOMAIN, CLIENT_ID, IDENTIFIER } from './data-provider';
import { version } from '../package.json';
import { HelmetProvider } from 'react-helmet-async';

const userToken = JSON.parse(window.localStorage.getItem('user') || '{}');
const orgId = userToken?.organization?.id;
const appId = userToken?.platform?.id;

const params = new URL(window.location.href).searchParams;
const invitation = params.get('invitation');
const organization = params.get('organization');
const organizationName = params.get('organization_name');

console.log(
  '%cElobooks\n v%s',
  'color:#2196F3; font-size: 50pt; font-family:monospace; font-weight:bold;',
  version,
);

ReactDOM.render(
  <Auth0Provider
    domain={DOMAIN}
    clientId={CLIENT_ID}
    audience={IDENTIFIER}
    cacheLocation="localstorage"
    {...(orgId && { orgId: orgId })}
    {...(appId && { platformId: appId })}
    {...(invitation &&
      organization &&
      organizationName && { invitation, organization, organization_name: organizationName })}
    redirectUri={window.location.origin}
  >
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Auth0Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log) )
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
